export const api = "https://tan-cheetah-948803.hostingersite.com/server"; //local
export const domain = "https://tan-cheetah-948803.hostingersite.com"



// export const api = "http://localhost/lessons/server"; //local
// export const domain = "http://localhost"



